import React, { FC, useState } from 'react';
import { Button, BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import { UserIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { IssueType } from 'models/issue.model';
import { apiService } from 'utils/api';
import { selectedRep } from 'pages/cs/pending-tasks';

interface FinishOrderModalProps {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  issue: IssueType;
  selectedCsRep: selectedRep;
  resolution: string;
}

interface FinishOrderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const MarkAsDoneFooter: FC<FinishOrderFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const MarkAsDoneModal: FC<FinishOrderModalProps> = ({
  show,
  onClose,
  onSuccess,
  issue,
  resolution,
  selectedCsRep
}) => {
  const [loading, setLoading] = useState(false);

  const resolveModal = async () => {
    try {
      setLoading(true);
      await apiService.post('cs/issue/resolve', {
        data: {
          resolution,
          issue_id: issue?.id,
          resolved_by: selectedCsRep?.id
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });

      toast(<ToastMessage type='success' message='issue successfully resolved' />);
    } catch (err: any) {
      toast(<ToastMessage type='error' message='Error resolving issue, try again later' />);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const checkState = () => {
    resolveModal();
    onSuccess();
  };
  return (
    <BaseModal
      isOpen={show}
      title='Mark as done'
      description={`Are you sure you want to mark ${issue.user?.first_name}'s issue as resolved`}
      titleIcon={<UserIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={<MarkAsDoneFooter loading={loading} onCancel={onClose} onConfirm={checkState} />}
    />
  );
};

export default MarkAsDoneModal;
